<template>
	<div class="News">
		<div class="banner mb50">
			<div class="content">
				<div class="content_2">
					<div class="banner_img">
						<img src="../assets/News.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="pb40">
			<div class="content">
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-for="(item, i) in newsList" :key="i">
						<div class="News_item tran3" @click="look(item)">
							<div class="img mb20">
								<el-image style="width: 100%; height: 250px" :src="require(`@/assets/News_item_${item.img_index[0]+1}.jpg`)" :fit="'cover'"></el-image>
							</div>
							<div class="News_info">
								<div class="c3 f16 hang1 News_title b bred" :title="item.title">{{item.title}}</div>
								<div class="c6 f14 hang2 mb40" :title="item.descr">{{item.descr}}</div>
								<div>
									<div class="fl">{{item.date}}</div>
									<div class="fr bred"><i class="el-icon-plus"></i> 详情</div>
									<div class="cl"></div>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<el-dialog title="" v-model="show" width="63%" :show-close="false" :close-on-click-modal="true" destroy-on-close @open="$opened(this)">
			<div class="News_window">
				<div class="tz borb1">
					<div class="f30 b c3">{{dialog.title}}</div>
					<div class="f14 c9 ptb20">发布日期： {{dialog.date}}</div>
				</div>
				<div class="News_window_content" v-html="dialog.html"></div>
				<template v-if="dialog.videoList" v-for="url in dialog.videoList">
					<div class="img tz mt20">
						<video :src="url" controls :poster="dialog.imgList[0]" preload="metadata" style="width: 100%;"></video>
					</div>
				</template>
				<template v-else v-for="url in dialog.imgList">
					<div class="img tz mt20">
						<img :src="url" style="width: 100%;" />
					</div>
				</template>
				<div class="News_close bluebg" @click="show = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				newsList: [],
				show: false,
				dialog: {}
			}
		},
		created() {
			this.newsList = this.$store.state.newsList;
			this.newsList.forEach((x,i) => {
				x.imgList = x.img_index.map(m => require(`@/assets/News_item_${m+1}.jpg`));
				if (x.video_index) {
					x.videoList = x.video_index.map(m => require(`@/assets/News_item_${m+1}.mp4`));
				}
			})
		},
		mounted() {

		},
		methods: {
			look(item) {
				this.show = true;
				this.dialog = item;
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';
	.News {
		overflow: hidden;
		
		.el-dialog {
			border-radius: 0;
		}
		
		.banner {
			height: 360px;
			position: relative;
			background: url(../assets/News.jpg) no-repeat center;
			@media screen and (max-width: 768px) {
				height: 220px;
				background-size: cover;
				margin-bottom: 40px;
			}
		}

		.News_item {
			padding: 24px;
			box-sizing: border-box;
			border-radius: 5px;
			margin-bottom: 30px;
			cursor: pointer;
			@media screen and (max-width: 768px) {
				margin-bottom: 4vw;
				padding: 4vw;
			}
			
			.hang2 {
				height: 56px;
				@media screen and (max-width: 768px) {
					margin-bottom: 4vw;
					height: auto;
				}
			}

			.News_info {
				line-height: 2;
			}

			img {
				transition: all 0.3s;
				-webkit-transition: all 0.3s;
			}

			&:hover {
				box-shadow: 0 0 30px #d7d7d7;

				.bred {
					color: $blue;
				}

				img {
					transform: scale(1.05);
				}
				@media screen and (max-width: 768px) {
					box-shadow: none;
					img {
						transform: scale(1);
					}
				}
			}
		}
		
		.News_window {
			padding: 10px 30px 50px;
			box-sizing: border-box;
			background: #FFFFFF;
			position: relative;
		}
		
		.News_window_content {
			font-size: 16px;
			line-height: 2;
			
			p {
				margin-bottom: 20px;
				text-indent: 32px;
			}
			
			img {
				max-width: 770px;
				margin: 0 auto;
				display: block;
			}
		}
		
		.News_close {
			position: absolute;
			width: 50px;
			height: 50px;
			right: -70px;
			top: -60px;
			text-align: center;
			cursor: pointer;
			i {
				font-size: 30px;
				color: #FFFFFF;
				line-height: 50px;
			}
		}
	}
</style>
